import React from 'react';

import { Icon } from '@gerdau/hefesto';
import { Tooltip } from '@gerdau/hefesto/Tooltip';
import { TooltipContainer } from './styles';

const TextTooltipInformation = ({
  title,
  placement = 'bottomLeft',
  children
}: {
  title: string;
  placement?: 'bottomLeft' | 'topLeft';
  children: React.ReactNode;
}) => (
  <TooltipContainer>
    {children}{' '}
    <Tooltip {...{ title, placement }}>
      <div>
        <Icon option="Info" variant="info" size="xs" />
      </div>
    </Tooltip>
  </TooltipContainer>
);

export default TextTooltipInformation;
